import { z } from 'zod';

export const MAX_CASH_PAYMENT_TERM_DAYS = 3650;
/** Null clears a manual override; zero means same-day cash. */
export const RecurringPaymentTermDaysSchema = z
  .number()
  .int()
  .min(0)
  .max(MAX_CASH_PAYMENT_TERM_DAYS)
  .nullable();

/** Server-owned evidence, never a writable input. */
export const RecurringPaymentTermEstimateSchema = z.object({
  days: z.number().int(),
  sampleSize: z.number().int().min(1).max(6),
  basis: z.enum(['DOCUMENT_DUE_DATE', 'SCHEDULED_DATE', 'MIXED']),
});
export type RecurringPaymentTermEstimate = z.infer<typeof RecurringPaymentTermEstimateSchema>;

export const CashPaymentCalendarSchema = z.object({
  mode: z.enum(['WEEKDAYS', 'MONTH_DAYS']),
  days: z.array(z.number().int()),
});
export type CashPaymentCalendar = z.infer<typeof CashPaymentCalendarSchema>;

export const CashDateResolutionSchema = z.object({
  date: z.string(),
  source: z.enum([
    'PAID_DATE',
    'SCHEDULED_DATE',
    'DOCUMENT_DUE_DATE',
    'MANUAL_TERM',
    'HISTORICAL_TERM',
    'ENTITY_CALENDAR',
    'COMPETENCY_FALLBACK',
  ]),
  days: z.number().int().optional(),
  sampleSize: z.number().int().optional(),
  basis: RecurringPaymentTermEstimateSchema.shape.basis.optional(),
  calendar: CashPaymentCalendarSchema.optional(),
});
export type CashDateResolution = z.infer<typeof CashDateResolutionSchema>;
